<template>
  <div class="verify-page">
    <div class="verify-sheet">
      <div class="verify-head">
        <img :src="logoSrc" alt="CHED" class="verify-logo" />
        <div>
          <h1>Pass Slip Verification</h1>
          <p>CHED Caraga Regional Office · CCMIS</p>
        </div>
      </div>

      <div v-if="loading" class="verify-msg">Checking record…</div>

      <div v-else-if="error" class="verify-msg verify-bad">
        <strong>Not verified.</strong> {{ error }}
      </div>

      <div v-else-if="result && result.valid" class="verify-body">
        <p class="verify-ok"><strong>Approved pass slip on file.</strong></p>
        <p class="verify-note">If a printed copy was shown to you, compare the name, date, and times below. Tampered copies will not match this record.</p>

        <table class="verify-tbl">
          <tbody>
            <tr>
              <td>Reference no.</td>
              <td>{{ result.pass_slip.reference_no }}</td>
            </tr>
            <tr>
              <td>Name</td>
              <td>{{ result.pass_slip.requester_name }}</td>
            </tr>
            <tr>
              <td>Position</td>
              <td>{{ result.pass_slip.requester_position || "—" }}</td>
            </tr>
            <tr>
              <td>Office</td>
              <td>{{ result.pass_slip.requesting_office || "—" }}</td>
            </tr>
            <tr>
              <td>Date / time away</td>
              <td>{{ timeAwayText(result.pass_slip) }}</td>
            </tr>
            <tr>
              <td>Filed</td>
              <td>{{ formatDateTime(result.pass_slip.submitted_at) }}</td>
            </tr>
            <tr>
              <td>Approved</td>
              <td>{{ formatDateTime(result.pass_slip.approved_at) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {
  formatPassSlipDateTime,
  passSlipTimeAwayText,
} from "@/utils/passSlipHelpers";

export default {
  name: "VerifyPassSlipPage",
  data() {
    return {
      loading: true,
      error: null,
      result: null,
      logoSrc: require("@/assets/images/login-page-ched-logo.png"),
    };
  },
  methods: {
    formatDateTime: formatPassSlipDateTime,
    timeAwayText: passSlipTimeAwayText,
    async verify() {
      const ref = this.$route.query.ref;
      const sig = this.$route.query.sig;
      if (!ref || !sig) {
        this.error = "Invalid link.";
        this.loading = false;
        return;
      }

      try {
        const { data } = await axios.get("api/pass-slip/verify", {
          params: { ref, sig },
        });
        this.result = data;
      } catch (e) {
        this.error = (e.response && e.response.data && e.response.data.message)
          || "Record not found or no longer valid.";
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.verify();
  },
};
</script>

<style scoped>
.verify-page {
  min-height: 100vh;
  background: #e8e8e8;
  padding: 24px 16px;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 12pt;
  color: #000;
}

.verify-sheet {
  max-width: 520px;
  margin: 0 auto;
  background: #fff;
  border: 1px solid #bbb;
  padding: 20px 22px;
}

.verify-head {
  display: flex;
  gap: 12px;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #ccc;
}

.verify-logo {
  width: 48px;
  height: 48px;
  object-fit: contain;
}

.verify-head h1 {
  font-size: 14pt;
  font-weight: bold;
  margin: 0;
}

.verify-head p {
  margin: 2px 0 0;
  font-size: 9pt;
  color: #444;
}

.verify-msg {
  padding: 12px 0;
  font-size: 11pt;
}

.verify-bad {
  color: #800;
}

.verify-ok {
  margin: 0 0 12px;
  font-size: 11pt;
}

.verify-note {
  margin: 0 0 12px;
  font-size: 9.5pt;
  color: #444;
}

.verify-tbl {
  width: 100%;
  border-collapse: collapse;
  font-size: 10.5pt;
}

.verify-tbl td {
  border: 1px solid #999;
  padding: 6px 8px;
  vertical-align: top;
}

.verify-tbl td:first-child {
  width: 38%;
  background: #f5f5f5;
  font-weight: bold;
}
</style>
